import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "Bulk policy edit", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createTextVNode("Download "),
  /*#__PURE__*/_createElementVNode("a", { href: "/bulk.csv" }, "sample file"),
  /*#__PURE__*/_createTextVNode(".")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FileUpload = _resolveComponent("FileUpload")!
  const _component_PrimeColumn = _resolveComponent("PrimeColumn")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_DodoButton = _resolveComponent("DodoButton")!
  const _component_DodoRow = _resolveComponent("DodoRow")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _createVNode(_component_FileUpload, {
      "custom-upload": true,
      accept: "text/csv",
      onUploader: _ctx.upload
    }, null, 8, ["onUploader"]),
    _hoisted_5,
    (_ctx.previewEntries)
      ? (_openBlock(), _createBlock(_component_DataTable, {
          key: 0,
          value: _ctx.previewEntries,
          "responsive-layout": "scroll",
          paginator: true,
          rows: 10,
          "paginator-template": "CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown",
          "rows-per-page-options": [10,25,100],
          "current-page-report-template": "Showing {first} to {last} of {totalRecords}",
          "row-class": _ctx.rowClass
        }, {
          default: _withCtx(() => [
            _createVNode(_component_PrimeColumn, {
              field: "rowNumber",
              header: "Row",
              sortable: true
            }),
            _createVNode(_component_PrimeColumn, {
              field: "entry.type",
              header: "Type",
              sortable: true
            }),
            _createVNode(_component_PrimeColumn, {
              field: "entry.reference",
              header: "Reference",
              sortable: true
            }),
            _createVNode(_component_PrimeColumn, {
              field: "message",
              header: "Result",
              sortable: true
            })
          ]),
          _: 1
        }, 8, ["value", "row-class"]))
      : _createCommentVNode("", true),
    _hoisted_6,
    (_ctx.previewEntries)
      ? (_openBlock(), _createBlock(_component_DodoRow, {
          key: 1,
          gap: "s"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_DodoButton, {
              color: "info",
              variant: "solid",
              onClick: _ctx.continueProcessing
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Continue ")
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_DodoButton, {
              color: "info",
              onClick: _cache[0] || (_cache[0] = () => _ctx.previewEntries = null)
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Cancel ")
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}